export default __webpack_public_path__ + "static/media/Ubuntu-LI.b94e8651.woff";